<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      Connect.S
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageChannelManagerSu.card.general')" cols="12 6@desktop" rows="2">
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageChannelManagerSu.enabled')"
                           v-model="config.enabled"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           :disabled="!config.created || isEmpty(config.defaultIhs)"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <hm-input-select v-if="hasRole('ROLE_SYSADMIN')"
                           v-model="config.apiVersion"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                           label="API-Version"
                           enum-name="SuApiVersion"
                           cols="12 6@hd start-1"
                           name="apiVersion" />
        </hm-card-inner>
        <hm-card-inner v-if="!config.enabled" :full-size="true">
          <hm-col cols="12">
            <span class="warning-text warning-text--full-size warning-text--no-margin col-12">Interface is <b><u>DISABLED</u></b>. Reservations will <b><u>NOT</u></b> be imported. Availability changes will <b><u>NOT</u></b> be synced. Price changes will <b><u>NOT</u></b> be synced.</span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageChannelManagerSu.card.tenant')">
          <hm-input-toggle :label="$t('admin.interfaces.pageChannelManagerSu.chainCreated')"
                           v-model="config.chainCreated"
                           :disabled="true"
                           cols="12 6@hd start-1"
                           name="chainCreated" />
          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.chainId')"
                    v-model="config.chainId"
                    :disabled="config.chainCreated || config.created || !hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                    cols="12 6@hd start-1"
                    name="chainId" />
          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.chainName')"
                    :disabled="config.chainCreated"
                    :maxlength="20"
                    :validate="'regex:^[0-9a-zA-z ]{0,20}$'"
                    v-model="config.chainName"
                    cols="12 6@hd start-1"
                    name="chainName" />
          <!--          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.chainName')"-->
          <!--                    :value="hotelSettings.hotel.hotelName"-->
          <!--                    :disabled="true"-->
          <!--                    cols="12 6@hd start-1"-->
          <!--                    name="chainName" />-->
          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.chainPhoneNumber')"
                    :value="hotelSettings.details.reservationPhoneNumber"
                    :disabled="true"
                    cols="12 6@hd start-1"
                    name="chainPhoneNumber" />
          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.contactGivenName')"
                    v-model="config.contactGivenName"
                    cols="12 6@hd start-1"
                    name="contactGivenName" />
          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.contactSurname')"
                    v-model="config.contactSurname"
                    cols="12 6@hd start-1"
                    name="contactSurname" />
          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.chainContact')"
                    :value="`${config.contactGivenName || ''} ${config.contactSurname || ''}`.trim()"
                    :disabled="true"
                    cols="12 6@hd start-1"
                    name="chainContact" />
          <hm-col v-if="isPartnerAdmin() || hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')" cols="start-1 12 6@hd">
            <span class="warning-text">
              If the email address is already used for another user (global user or chain user) the existing user will be deleted. We therefore strongly recommend using the <b>hotel email address</b>.
            </span>
          </hm-col>
          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.chainUserEmail')"
                    v-model="config.chainUserEmail"
                    :disabled="config.chainCreated || !hasRole('ROLE_SYSADMIN')"
                    cols="12 6@hd start-1"
                    name="chainUserEmail" />
        </hm-card-inner>
        <hm-card-inner :title="$t('admin.interfaces.pageChannelManagerSu.card.hotel')">
          <hm-input-toggle :label="$t('admin.interfaces.pageChannelManagerSu.created')"
                           v-model="config.created"
                           :disabled="true"
                           cols="12 6@hd start-1"
                           name="created" />

          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.hotelId')"
                    :value="config.hotelId"
                    :disabled="true"
                    cols="12 6@hd start-1"
                    name="hotelId" />
          <hm-input-select :label="$t('admin.interfaces.pageChannelManagerSu.hotelType')"
                           v-model="config.hotelType"
                           :disabled="config.created"
                           enum-name="SuHotelType"
                           cols="12 6@hd start-1"
                           name="hotelType" />
          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.propertyLicenseNumber')"
                    v-model="config.propertyLicenseNumber"
                    cols="12 6@hd start-1"
                    name="propertyLicenseNumber" />
        </hm-card-inner>
        <hm-card-inner>
          <hm-multiselect id="excludedRoomTypes"
                          v-model="config.excludedRoomTypes"
                          :options="hotelSettings.roomTypes.all(config.excludedRoomTypes)"
                          :label="$t('admin.interfaces.pageChannelManagerSu.excludedRoomTypes')"
                          :label-expression="`\${option.name.${hotelSettings.details.primaryLanguage}}`"
                          cols="12 6@hd start-1"
                          name="excludedRoomTypes"/>
          <hm-multiselect id="excludedRatePlans"
                          v-model="config.excludedRatePlans"
                          :options="hotelSettings.ratePlans.all(config.excludedRatePlans).filter(it => it.ratePlanType === 'DayRate')"
                          :label="$t('admin.interfaces.pageChannelManagerSu.excludedRatePlans')"
                          :label-expression="`\${option.name.${hotelSettings.details.primaryLanguage}}`"
                          cols="12 6@hd start-1"
                          name="excludedRatePlans" />
        </hm-card-inner>
      </card>
      <card :title="$t('admin.interfaces.pageChannelManagerSu.card.paymentGateway')" cols="12 6@desktop">
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageChannelManagerSu.stripeEnabled')"
                           v-model="config.stripeEnabled"
                           :disabled="isEmpty(config.stripePublicKey)"
                           cols="12 6@hd start-1"
                           name="stripeEnabled" />
          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.stripePublicKey')"
                    v-model="config.stripePublicKey"
                    cols="12 6@hd start-1"
                    name="stripePublicKey" />
          <hm-input :label="$t('admin.interfaces.pageChannelManagerSu.stripeSecretKey')"
                    v-model="config.stripeSecretKey"
                    help="Value is not being displayed (once it's stored) because of security reasons."
                    cols="12 6@hd start-1"
                    name="stripeSecretKey" />
        </hm-card-inner>
      </card>
      <card title="Default Extra/Addon Mapping" cols="12 6@desktop">
        <hm-card-inner full-size>
          <hm-col cols="12">
            <span class="info-text info-text--full-size info-text--no-margin col-12">
              Only services configured "per room per stay" can be selected.<br/><br/>
              <i>We do recommend using a service with the highest VAT in your country as a fallback, to prevent being accused of VAT fraud, in case you forget to change the service type, before creating the invoice</i>
            </span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner>
          <hm-input-select v-model="config.defaultIhs"
                           label="Default Service"
                           help="Is being used if no other service mapping matches."
                           cols="12 6@hd">
            <option v-for="item in hotelSettings.inHouseServices.all(config.defaultIhs).filter(it => it.id === config.defaultIhs || (it.rateFrequency === 'PerStay' && it.rateMode === 'PerRoom' && it.type !== 'PrePayment'))"
                    :disabled="item.rateFrequency !== 'PerStay' || item.rateMode !== 'PerRoom'"
                    :value="item.id"
                    v-html="item.name[$shortLocale]"></option>
            <template slot="icon-inline-right" slot-scope="slot">
              <input-icon-button v-tooltip="{ title: 'Auto-Create default mapping iHS', delay: 0, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                                 :border="true"
                                 :disabled="!isEmpty(config.defaultIhs)"
                                 icon="plus"
                                 @click="createDefaultIhsMapping" />
            </template>
          </hm-input-select>
        </hm-card-inner>
      </card>
      <card title="Extra Components" cols="12 6@desktop">
        <hm-card-inner full-size>
          <hm-col cols="12">
            <span class="info-text info-text--full-size info-text--no-margin col-12">
              Only services configured "per room per stay" can be selected.
            </span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner :full-size="true">
          <hm-table :hover="false"
                    columns="2"
                    grid-template-columns="1fr 1fr">
            <template slot="table-head">
              <div class="hm-table__th">Name</div>
              <div class="hm-table__th">Service</div>
            </template>
            <template v-for="(it, itIdx) in config.extraMapping">
              <div class="hm-table__td">
                <hm-input :inline="true"
                          :id="`extra-mapping-label-${itIdx}`"
                          v-model="it.name"
                          label="Name"
                          name="name" />
              </div>
              <div class="hm-table__td">
                <hm-input-select v-model="it.ihsId"
                                 :id="`ihsId-${itIdx}`"
                                 :inline="true"
                                 label="Service"
                                 cols="12 6@hd">
                  <option :value="null"></option>
                  <option v-for="item in hotelSettings.inHouseServices.all(it.ihsId).filter(it => it.id === it.ihsId || (it.rateFrequency === 'PerStay' && it.rateMode === 'PerRoom' && it.type !== 'PrePayment'))"
                          :disabled="item.rateFrequency !== 'PerStay' || item.rateMode !== 'PerRoom'"
                          :value="item.id"
                          v-html="item.name[$shortLocale]"></option>
                </hm-input-select>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
        <hm-card-inner title="Items to Ignore">
          <template v-for="(ignore, ignoreIdx) in config.ignoreExtras">
            <hm-input v-model="config.ignoreExtras[ignoreIdx]"
                      :key="ignoreIdx"
                      label="Ignore Extra"
                      help="Extra that should not be imported."
                      cols="12 start-1" />
          </template>
        </hm-card-inner>
      </card>
      <card title="Addons" cols="12 6@desktop">
        <hm-card-inner :full-size="true" title="Addons">
          <hm-table :hover="false"
                    columns="2"
                    grid-template-columns="1fr 1fr">
            <template slot="table-head">
              <div class="hm-table__th">Name</div>
              <div class="hm-table__th">Service</div>
            </template>
            <template v-for="(it, itIdx) in config.addonMapping">
              <div class="hm-table__td">
                <hm-input :inline="true"
                          :id="`addon-mapping-label-${itIdx}`"
                          v-model="it.name"
                          label="Name"
                          name="name" />
              </div>
              <div class="hm-table__td">
                <hm-input-select v-model="it.ihsId"
                                 :id="`ihsId-${itIdx}`"
                                 :inline="true"
                                 label="Service"
                                 cols="12 6@hd">
                  <option :value="null"></option>
                  <option v-for="item in hotelSettings.inHouseServices.all(it.ihsId).filter(it => it.id === it.ihsId || it.type !== 'PrePayment')"
                          :value="item.id"
                          v-html="item.name[$shortLocale]"></option>
                </hm-input-select>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
        <hm-card-inner title="Items to Ignore">
          <template v-for="(ignore, ignoreIdx) in config.ignoreAddons">
            <hm-input v-model="config.ignoreAddons[ignoreIdx]"
                      :key="ignoreIdx"
                      label="Ignore Addon"
                      help="Addon that should not be imported."
                      cols="12 start-1" />
          </template>
        </hm-card-inner>
      </card>
      <card title="Extra Fees" cols="12 6@desktop">
        <hm-card-inner full-size>
          <hm-col cols="12">
            <span class="info-text info-text--full-size info-text--no-margin col-12">
              Only services configured "per room per stay" can be selected. <b>Currently only supported by Airbnb</b>
            </span>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner :full-size="true">
          <hm-table :hover="false"
                    columns="2"
                    grid-template-columns="1fr 1fr">
            <template slot="table-head">
              <div class="hm-table__th">Name</div>
              <div class="hm-table__th">Service</div>
            </template>
            <template v-for="(it, itIdx) in config.extraFeesMapping">
              <div class="hm-table__td">
                <hm-input :inline="true"
                          :id="`extra-fee-label-${itIdx}`"
                          v-model="it.name"
                          label="Name"
                          name="name" />
              </div>
              <div class="hm-table__td">
                <hm-input-select v-model="it.ihsId"
                                 :id="`ihsId-${itIdx}`"
                                 :inline="true"
                                 label="Service"
                                 cols="12 6@hd">
                  <option :value="null"></option>
                  <option v-for="item in hotelSettings.inHouseServices.all(it.ihsId).filter(it => it.id === it.ihsId || (it.rateFrequency === 'PerStay' && it.rateMode === 'PerRoom' && it.type !== 'PrePayment'))"
                          :disabled="item.rateFrequency !== 'PerStay' || item.rateMode !== 'PerRoom'"
                          :value="item.id"
                          v-html="item.name[$shortLocale]"></option>
                </hm-input-select>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
        <hm-card-inner title="Items to Ignore">
          <template v-for="(ignore, ignoreIdx) in config.ignoreExtraFees">
            <hm-input v-model="config.ignoreExtraFees[ignoreIdx]"
                      :key="ignoreIdx"
                      label="Ignore Extra Fee"
                      help="Extra Fee that should not be imported."
                      cols="12 start-1" />
          </template>
        </hm-card-inner>
      </card>
      <card title="Room Type Codes" cols="12 6@desktop start-1">
        <hm-card-inner :full-size="true">
          <hm-table :hover="true"
                    min-width="400px"
                    columns="2"
                    grid-template-columns="2fr 1fr">
            <template v-for="roomTypeId in config.roomTypes">
              <template v-if="!isEmpty(roomTypeMap[roomTypeId].additionalFields.CM_SU_ID)">
                <div class="hm-table__td">{{ roomTypeMap[roomTypeId].name[hotelSettings.details.primaryLanguage] }} ({{ roomTypeId }})</div>
                <div class="hm-table__td" @click="$copy(roomTypeMap[roomTypeId].additionalFields.CM_SU_ID)">{{ roomTypeMap[roomTypeId].additionalFields.CM_SU_ID }}</div>
              </template>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>
      <card title="Rate Plan Codes" cols="12 6@desktop">
        <hm-card-inner :full-size="true">
          <hm-table :hover="true"
                    min-width="400px"
                    columns="2"
                    grid-template-columns="2fr 1fr">
            <template v-for="ratePlanId in config.ratePlans">
              <template v-if="!isEmpty(ratePlanMap[ratePlanId].additionalFields.CM_SU_ID)">
                <div class="hm-table__td">{{ ratePlanMap[ratePlanId].name[hotelSettings.details.primaryLanguage] }}</div>
                <div class="hm-table__td" @click="$copy(ratePlanMap[ratePlanId].additionalFields.CM_SU_ID)">{{ ratePlanMap[ratePlanId].additionalFields.CM_SU_ID }}</div>
              </template>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>
    </template>
    <hm-floating-buttons v-if="!isNil(config)">
      <hm-floating-button label="Show more" icon="fill-more" color="gray">
        <hm-floating-child-button :throttle="10000"
                                  label="Delete Instance"
                                  icon="delete"
                                  color="red"
                                  @click="deleteInstance()" />
        <hm-floating-child-button :throttle="10000"
                                  label="Create/Update Chain"
                                  icon="upload"
                                  color="orange"
                                  @click="performAction('chain')" />
        <hm-floating-child-button v-if="config.chainCreated"
                                  :throttle="10000"
                                  label="Create/Update Instance"
                                  icon="upload"
                                  color="orange"
                                  @click="performAction('create')" />
        <hm-floating-child-button v-if="config.created"
                                  :throttle="3500"
                                  label="Update Payment Gateway"
                                  icon="upload"
                                  color="orange"
                                  @click="performAction('paymentGateway')" />
        <hm-floating-child-button v-if="config.created"
                                  :throttle="3500"
                                  label="Create/Update Room Types"
                                  icon="upload"
                                  color="orange"
                                  @click="performAction('roomTypes')" />
        <hm-floating-child-button v-if="config.created && config.apiVersion === 'v2'"
                                  :throttle="3500"
                                  label="Create/Update Images"
                                  icon="upload"
                                  color="orange"
                                  @click="performAction('images')" />
        <hm-floating-child-button v-if="config.created"
                                  :throttle="3500"
                                  label="Create/Update Rate Plans"
                                  icon="upload"
                                  color="orange"
                                  @click="performAction('ratePlans')" />
        <hm-floating-child-button v-if="config.created"
                                  :throttle="3500"
                                  label="Update Rates & Availabilities"
                                  icon="upload"
                                  color="orange"
                                  @click="performAction('updateRatesAndAvailabilities')" />
        <hm-floating-child-button v-if="config.created"
                                  :disabled="isEmpty(config.defaultIhs)"
                                  :throttle="3500"
                                  label="Retrieve Reservations"
                                  icon="download"
                                  color="orange"
                                  @click="performAction('reservations')" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, first, groupBy, indexOf, isEmpty, isNil, keyBy, maxBy, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import UpdateHotelSettingsMixin from '../../../../mixins/UpdateHotelSettingsMixin';
import HmInputSelect from '../../../lib/inputs/HmInputSelect';
import AutoAddNewRowsMixin from '../../../../mixins/AutoAddNewRowsMixin';

export default {
  name: 'PageChannelManagerSu',
  components: { HmInputSelect, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin, UpdateHotelSettingsMixin, AutoAddNewRowsMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        const config = cloneDeep(this.config);

        config.extraFeesMapping = Object.fromEntries(config.extraFeesMapping.filter(it => !isEmpty(it.name) && !isEmpty(it.ihsId)).map(it => [it.name, it.ihsId]));
        config.extraMapping = Object.fromEntries(config.extraMapping.filter(it => !isEmpty(it.name) && !isEmpty(it.ihsId)).map(it => [it.name, it.ihsId]));
        config.addonMapping = Object.fromEntries(config.addonMapping.filter(it => !isEmpty(it.name) && !isEmpty(it.ihsId)).map(it => [it.name, it.ihsId]));

        this.axios.put(this.serviceUrls.interfaces.channelManagerSu.get(this), config)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    roomTypeMap: function () {
      return keyBy(this.hotelSettings.roomTypes, 'id');
    },
    ratePlanMap: function () {
      return keyBy(this.hotelSettings.ratePlans, 'id');
    },
  },

  watch: {
    'config.ignoreExtras': {
      handler: function () {
        if (isNil(this.config.ignoreExtras)) this.$set(this.config, 'ignoreExtras', []);
        this.autoAddNewRows(
          this.config.ignoreExtras,
          '',
          it => isEmpty(it),
        );
      },
      deep: true,
    },
    'config.ignoreExtraFees': {
      handler: function () {
        if (isNil(this.config.ignoreExtraFees)) this.$set(this.config, 'ignoreExtraFees', []);
        this.autoAddNewRows(
          this.config.ignoreExtraFees,
          '',
          it => isEmpty(it),
        );
      },
      deep: true,
    },
    'config.ignoreAddons': {
      handler: function () {
        if (isNil(this.config.ignoreAddons)) this.$set(this.config, 'ignoreAddons', []);
        this.autoAddNewRows(
          this.config.ignoreAddons,
          '',
          it => isEmpty(it),
        );
      },
      deep: true,
    },
    'config.extraFeesMapping': {
      handler: function () {
        this.autoAddNewRows(
          this.config.extraFeesMapping,
          {
            name: null,
            ihsId: null,
          },
          it => isEmpty(it.name) && isEmpty(it.ihsId),
        );
      },
      deep: true,
    },
    'config.extraMapping': {
      handler: function () {
        this.autoAddNewRows(
          this.config.extraMapping,
          {
            name: null,
            ihsId: null,
          },
          it => isEmpty(it.name) && isEmpty(it.ihsId),
        );
      },
      deep: true,
    },
    'config.addonMapping': {
      handler: function () {
        this.autoAddNewRows(
          this.config.addonMapping,
          {
            name: null,
            ihsId: null,
          },
          it => isEmpty(it.name) && isEmpty(it.ihsId),
        );
      },
      deep: true,
    },
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    isEmpty,
    performAction(action) {
      if (action === 'create' && !this.hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') && !['Hotelmeister', 'Rainmaker'].includes(this.hotelSettings.hotel.whiteLabel)) {
        this.showErrorMessage('Access Denied. Please contact support.');
        return;
      }
      this.axios.post(this.serviceUrls.interfaces.channelManagerSu[action](this))
        .then((response) => {
          this.showSuccessMessage();
          this.showMessages(response);
          this.loadData();
          this.$serviceBus.$emit('hotelSettings.update.immediate');
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.channelManagerSu.get(this))
        .then((response) => {
          const tmp = response.data.data;
          tmp.extraFeesMapping = Object.entries(tmp.extraFeesMapping).map(it => ({ name: it[0], ihsId: it[1] }));
          tmp.extraMapping = Object.entries(tmp.extraMapping).map(it => ({ name: it[0], ihsId: it[1] }));
          tmp.addonMapping = Object.entries(tmp.addonMapping).map(it => ({ name: it[0], ihsId: it[1] }));
          this.config = tmp;
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    deleteInstance(force = false) {
      if (force) {
        this.axios.delete(this.serviceUrls.interfaces.channelManagerSu.delete(this))
          .then((response) => {
            this.showSuccessMessage();
            this.showMessages(response);
            this.loadData();
            this.$serviceBus.$emit('hotelSettings.update.immediate');
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          });
      } else {
        this.showConfirmModal(
          this.$t('admin.interfaces.pageChannelManagerSu.confirmDelete', [this.hotelSettings.hotel.hotelName]),
          () => this.deleteInstance(true),
          this.$t('admin.interfaces.pageChannelManagerSu.confirmDeleteWarning'),
        );
      }
    },
    createDefaultIhsMapping() {
      const today = this.$moment()
        .format('YYYYMMDD');
      const isValidToday = function (dateRanges) {
        return dateRanges.some((dateRange) => {
          if ((dateRanges.validFrom || '19700101') > today) return false;
          else if ((dateRanges.validTo || '20991231') < today) return false;
          else return true;
        });
      };

      const validVats = this.hotelSettings.taxes.all()
        .filter(it => it.taxType === 'VAT')
        .filter(it => isEmpty(it.vavalidityDateRanges) || isValidToday(it.validityDateRanges));

      const maxVat = maxBy(validVats, 'amount');

      if (isNil(maxVat)) {
        this.showErrorMessage('No valid VAT found');
      } else {
        this.axios.post(this.serviceUrls.inHouseService.list(this), {
          name: {
            [this.hotelSettings.details.primaryLanguage]: (this.hotelSettings.details.primaryLanguage === 'de' ? 'Sonstige OTA Zusatzleistung' : 'Other OTA additional service'),
          },
          description: {
            [this.hotelSettings.details.primaryLanguage]: '',
          },
          type: 'Others',
          inHouseServiceMode: 'Regular',
          applicableTaxes: [maxVat.id],
          ageCategories: [],
          level: 'RatePlan',
          rateMode: 'PerRoom',
          rateFrequency: 'PerStay',
          deleted: false,
        })
          .then((response) => {
            this.$serviceBus.$emit('hotelSettings.update.immediate');
            this.config.defaultIhs = response.data.data.id;
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
          });
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageChannelManagerSu.vue